export const sentenceCase = (str) => {
    if ((str === null) || (str === "")) {
        return false
    }

    return str.toString().replace(/\w\S*/g,(txt) => (txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()))
}
